"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToAge = void 0;
const date_to_age_1 = require("../date-to-age/date-to-age");
const string_to_date_1 = require("../string-to-date/string-to-date");
/**
 * Converts a string date to an age.
 * @public
 *
 * @param dateAsString - The date as a string.
 *
 * @returns The age or 0 if the date is invalid.
 *
 * @example
 * ```ts
 * // if today is 01/01/2020
 * const result = stringToAge('01/01/1970');
 * console.log(result);
 * // -> 50
 * ```
 */
function stringToAge(dateAsString) {
    const birthDate = (0, string_to_date_1.stringToDate)(dateAsString);
    return birthDate ? (0, date_to_age_1.dateToAge)(birthDate) : 0;
}
exports.stringToAge = stringToAge;
//# sourceMappingURL=string-to-age.js.map